var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentalincome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-pawapt",
    "aria-label": "money-up",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7927 9.2052L15.2069 5.79105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5748 5.65456C11.575 5.60903 11.612 5.57224 11.6575 5.57232C11.703 5.5724 11.7399 5.60933 11.7399 5.65486C11.7399 5.70038 11.703 5.73731 11.6575 5.73739C11.612 5.73747 11.575 5.70068 11.5748 5.65516V5.65456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99833 6.99792V5.29721C7.99833 3.47391 9.47641 1.99583 11.2997 1.99583H15.7015C17.5248 1.99583 19.0029 3.47391 19.0029 5.29721V9.69904C19.0029 11.5223 17.5248 13.0004 15.7015 13.0004H15.0012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4264 9.3417C15.4263 9.38722 15.3893 9.42401 15.3437 9.42393C15.2982 9.42385 15.2614 9.38692 15.2614 9.34139C15.2614 9.29587 15.2982 9.25894 15.3437 9.25886C15.3893 9.25878 15.4263 9.29557 15.4264 9.34109V9.3417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0029 16.0017V21.0037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0021 18.0025L19.0029 16.0017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 18.0025L19.0029 16.0017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99625 12.6003V19.4031C2.99739 20.2869 4.78785 21.0037 6.99791 21.0037C9.20797 21.0037 10.9984 20.2869 10.9996 19.4031V12.6003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 12.6002C10.9984 13.484 9.20683 14.2009 6.99677 14.2009C4.78671 14.2009 2.99625 13.484 2.99625 12.6002C2.99625 11.7153 4.78899 10.9996 6.99791 10.9996C9.20683 10.9996 10.9984 11.7164 10.9996 12.6002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99682 16.0017C2.99682 16.8855 4.78728 17.6023 6.99734 17.6023C9.20741 17.6023 10.999 16.8855 10.999 16.0017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalincome);
export default __webpack_public_path__ + "static/media/rentalincome.3ed04411d71a634a32ffc1fcb06db5cc.svg";
export { ForwardRef as ReactComponent };